import DocumentationForm from "./DocumentationForm.container";

export default DocumentationForm;
